import { z } from 'zod';
export var NoteFormValues = z.object({
  subject: z.string(),
  content: z.string(),
  restricted: z["boolean"](),
  emailNotification: z["boolean"](),
  attachments: z.array(z.object({
    errorMessage: z.string().optional(),
    warningMessage: z.string().optional(),
    uploading: z["boolean"]().optional(),
    file: z["instanceof"](File),
    id: z.string()
  })),
  noteTemplateNumber: z.string().nullable(),
  parentNoteId: z.string().nullable()
});